import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import NextGenAutomationHero from "./sections/NextGenAutomationHero";
import TheAirobotMission from "./sections/TheAirobotMission";
import CorePlatformCapabilities from "./sections/CorePlatformCapabilities";
import WhyChooseUs from "./sections/WhyChooseUs";
import OQueDizemNossosClientes from "./sections/OQueDizemNossosClientes";
import LetsTalkStrategy from "./sections/LetsTalkStrategy";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <NextGenAutomationHero />
      <TheAirobotMission />
      <CorePlatformCapabilities />
      <WhyChooseUs />
      <OQueDizemNossosClientes />
      <LetsTalkStrategy />
      <Footer />
    </div>;
}